import React, { useState, useEffect } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { useToast } from '../controller/ToastController';
import StoreController, { VoucherType } from '../controller/StoreController';
import { decryptURLString } from '../utils/dataEncrypte';

const RestaurantVoucher = () => {
  let params = useParams();
  const showToast = useToast();
  const [couponVeiw, setCouponVeiw] = useState<boolean>(false);
  const [voucherData, setVoucherData] = useState<VoucherType>();
  const [errorText, setErrorText] = useState<string>('');

  const getVoucher = async () => {
    try {
      if (params && params.voucher_history_id) {
        const oParams = {
          voucher_history_id: decryptURLString(params.voucher_history_id),
        };
        const oRes: any = await StoreController.getVoucher(oParams);
        if (oRes && oRes.data.data.success) {
          setVoucherData(oRes.data.data.voucher_data);
          setCouponVeiw(true);
        } else {
          setCouponVeiw(false);
          setErrorText(oRes.data.data.msg);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const usesVoucher = async () => {
    try {
      if (params && params.voucher_history_id) {
        const oParams = {
          voucher_history_id: decryptURLString(params.voucher_history_id),
        };
        const oRes: any = await StoreController.usesVoucher(oParams);

        if (oRes.data.data.success) {
          showToast('사용완료 처리되었습니다');
          getVoucher();
        } else {
          showToast(oRes.data.data.msg, 'error');
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  useEffect(() => {
    getVoucher();
  }, []);

  return (
    <Style>
      <div className="wrap">
        {couponVeiw ? (
          <div className="voucherContainer">
            <div className="title">
              <h2>노크노크 추천 맛집쿠폰</h2>
              <h1>직원확인</h1>
            </div>
            <div className="voucherDetailWrap">
              <img src={`${process.env.PUBLIC_URL}/img/coupon.png`} alt="쿠폰이미지" width="100%" />
              <div className="voucherDetail">
                <h5>{voucherData?.store_name}</h5>
                <h4>{voucherData?.benefit}</h4>
              </div>
            </div>

            <p className="noticeText">매장에서 주문 전, 할인쿠폰을 제시해 주세요</p>
            <div className="detailBox">
              <div className="detailContent">
                <h3>혜택</h3>
                <p>{voucherData?.benefit}</p>
              </div>
              <div className="detailContent">
                <h3>매장명</h3>
                <p>{voucherData?.store_name}</p>
              </div>
              <div className="detailContent">
                <h3>전화</h3>
                <p>{voucherData?.phone_number}</p>
              </div>
              <div className="detailContent">
                <h3>주소</h3>
                <p>{voucherData?.address}</p>
              </div>
              <div className="detailContent">
                <h3>유효기간</h3>
                <p>{moment(voucherData?.end_date).format('YYYY년 MM월 DD일')}</p>
              </div>
              <div className="detailContent">
                <h3>호텔</h3>
                <p>{voucherData?.hotel_name}</p>
              </div>
              <div className="detailContent">
                <p>{voucherData?.comment}</p>
              </div>
            </div>
            <button
              className={` sucessBtn ${voucherData?.used_at !== null && 'used'}`}
              onClick={usesVoucher}>
              사용완료
            </button>
          </div>
        ) : (
          <h2 style={{ textAlign: 'center' }}>{errorText}</h2>
        )}
      </div>
    </Style>
  );
};

export default RestaurantVoucher;

export const Style = styled.div`
  h1 {
    margin-top: 5px;
    font-size: 40px;
    font-weight: 400;
    line-height: 60px;
    color: #4dd2ae;
  }
  h2 {
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    color: #555;
  }
  h3 {
    font-size: 18px;
    font-weight: 600;
    line-height: 27px;
    color: #555;
  }
  h4 {
    font-size: 20px;
    font-weight: 600;
    color: #555;
  }
  h5 {
    font-size: 14px;
    font-weight: 700;
    color: #ffbe27;
  }
  p {
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    color: #555;
  }
  img {
    margin: 22px 0 10px 0;
  }

  .wrap {
    width: 100vw;
    min-height: 100vh;
    padding-top: 74px;
    padding-bottom: 34px;
    background: #fff;
  }
  .voucherContainer {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    padding: 0 3vw;
  }
  .title {
    font-family: 'JalnanGothic';
    text-align: center;
  }
  .voucherDetailWrap {
    position: relative;
  }
  .voucherDetail {
    width: 100%;
    text-align: center;
    position: absolute;
    display: block;
    top: 40%;
    h4 {
      width: 80%;
      margin: 0 auto;
      margin-top: 7%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .noticeText {
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    color: #ff4a4a;
  }

  .detailBox {
    margin: 22px 0 34px 0;
  }
  .detailContent {
    display: flex;
    align-items: flex-start;
    margin-bottom: 6px;
    gap: 10px;

    h3 {
      width: 20%;
      min-width: 20%;
    }
    p {
      word-break: keep-all;
    }
  }
  .detailContent:nth-child(4) {
    margin-bottom: 22px;
  }
  .detailContent:last-child {
    margin-top: 22px;
  }
  .sucessBtn {
    width: 100%;
    padding: 17px;
    font-size: 24px;
    font-weight: 700;
    background: #4dd2ae;
    color: #fff;
    border-radius: 15px;
  }
  .sucessBtn.used {
    background: #e5e5e5;
  }
`;
